/**
 * @generated SignedSource<<6c3f3a0dba8222a1de29670a2c85f820>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTypeGroupHeader$data = {
  readonly issueTypes: ReadonlyArray<{
    readonly avatar: {
      readonly small: string | null | undefined;
    } | null | undefined;
    readonly name: string;
  }>;
  readonly " $fragmentType": "IssueTypeGroupHeader";
};
export type IssueTypeGroupHeader$key = {
  readonly " $data"?: IssueTypeGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTypeGroupHeader",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueTypes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraJqlIssueTypeFieldValue"
};

(node as any).hash = "c41ff0fec0474c5d560ad8876417768f";

export default node;
